<app-wait-container class="flex-col height100p" [loading]="loading">
    <sm-toolbar class="flex-item-fixed">
        <p-button icon="fas fa-refresh" label="Aktualisieren" (onClick)="refresh()">
        </p-button>
        <p-button icon="fas fa-save" label="Objektdefinition exportieren" (onClick)="exportObjectDef()">
        </p-button>
        <p-button icon="fas fa-lightbulb" label="Anzahl Objekte ermitteln" (onClick)="getObjectCounts()">
        </p-button>
    </sm-toolbar>
    <div class="flex-row-split flex-item-fill" [style.height]="'calc(100% - 50px)'">
        <p-tree class="flex-item-fixed width400 full-height tree-items-full-width" [value]="tree" selectionMode="single" [filter]=true [filterBy]="'data.name,data.internalName,data.tableName,additional.fieldNames'" [(selection)]="selectedObjectTypeNode" (selectionChange)="selectedObjectTypeChanged($event)">
            <ng-template let-node pTemplate="default">
                <tree-item-with-icons [icons]="node.icons">
                    {{node.label}}
                    <span *ngIf="node.data?.internalName != null" class="internal-name"> ({{node.data?.internalName}})</span>
                    <span *ngIf="_Utils.hasProperty(objectCounts, node.data?.internalName)" class="col-red"> {{objectCounts[node.data?.internalName]}}</span>
                </tree-item-with-icons>
            </ng-template>
        </p-tree>
        <p-tabView *ngIf="selectedObjectType != null" class="flex-item-fill full-height direct-sub" [(activeIndex)]="tabIndex" (activeIndexChange)="activeTabChanged()">
            <p-tabPanel header="Definition">
                <div class="flex-col height100p">
                    <sm-toolbar>
                        <p-splitButton label="DH Generator" icon="fas fa-folder" [model]="dhGeneratorItems"></p-splitButton>
                        <span class="ml-2 mr-2">Name: <app-copy-clipboard-text [text]="getSelectedObjectType()?.name"></app-copy-clipboard-text></span>
                        <span class="mr-2">Interner Name: <app-copy-clipboard-text [text]="getSelectedObjectType()?.internalName"></app-copy-clipboard-text></span>
                        <span class="mr-2">ID: <app-copy-clipboard-text [text]="'' + getSelectedObjectType()?.Id"></app-copy-clipboard-text></span>
                        <span class="mr-2">Tabellenname: <app-copy-clipboard-text [text]="getSelectedObjectType()?.tableName"></app-copy-clipboard-text></span>
                        <span class="mr-2">Anzahl Objekte: {{_Utils.hasProperty(objectCounts, getSelectedObjectType()?.internalName) ? objectCounts[getSelectedObjectType()?.internalName] : '???'}}</span>
                        <button pButton *ngIf="getSelectedObjectType() != null && !_Utils.hasProperty(objectCounts, getSelectedObjectType().internalName)" icon="fas fa-lightbulb" label="Ermitteln" (click)="getObjectCounts(getSelectedObjectType()?.internalName)"></button>
                        <button pButton *ngIf="getSelectedObjectType() != null" icon="fas fa-lightbulb" label="Alle Objekte in enaio zeigen" (click)="openResultList(getSelectedObjectType())"></button>
                        <button pButton *ngIf="getSelectedObjectType() != null" icon="fas fa-cog" label="Rendition Cache-fixen" (click)="fixRenditionCache(getSelectedObjectType())"></button>
                    </sm-toolbar>
                    <sm-table2 class="flex-item-fill height100p" [data]="fieldsTable" (onCellClicked)="fieldCellClicked($event)"></sm-table2>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Maske">
                <app-enaio-form [fields]="selectedObjectType?.fields"></app-enaio-form>
            </p-tabPanel>
            <p-tabPanel header="Events">
                <app-frontend-script-editor #clientEventsScriptEditor class="height100p" [scripts]="scripts" (onSave)="saveClientEvent($event)">                               
                </app-frontend-script-editor>     
            </p-tabPanel>
            <p-tabPanel header="Import & Export">
                <sm-toolbar>
                    <p-button icon="fas fa-save" label="Exportieren" (onClick)="exportPrepare()"></p-button>
                    <p-button icon="fas fa-load" label="Importieren" (onClick)="importPrepare()"></p-button>
                </sm-toolbar>
                <app-enaio-import-options [def]="def" [(options)]="importOptions" (onAction)="import($event)">
                </app-enaio-import-options>
                <app-enaio-export-options [def]="def" [(options)]="exportOptions" (onAction)="export($event)">
                </app-enaio-export-options>
            </p-tabPanel>
            <p-tabPanel header="Benutzerrechte">
                <sm-table2 *ngIf="userRightsTable != null" class="height100p" [data]="userRightsTable"></sm-table2>
            </p-tabPanel>
            <p-tabPanel header="Relationen">
                <div class="height100p grid">
                    <sm-table2 *ngIf="relationsFromTable != null" class="col-6 height100p" [data]="relationsFromTable"></sm-table2>
                    <sm-table2 *ngIf="relationsToTable != null" class="col-6 height100p" [data]="relationsToTable"></sm-table2>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Eindeutige/Mehrfache Objekte finden">
                <p-tabView class="height100p full-height direct-sub" [(activeIndex)]="findDupsTabIndex">
                    <p-tabPanel header="Abfrage">
                        <div class="flex-col height100p">
                            <sm-toolbar>
                                <span>Maximale Ergebnismenge: <p-inputNumber [(ngModel)]="maxDups"></p-inputNumber></span>
                                <span class="ml-3">Finde: <p-dropdown [styleClass]="'width200'" [options]="[{label: 'Mehrfache', value: 2}, {label: 'Eindeutige', value: 1}]" optionLabel="label" optionValue="value" [(ngModel)]="dupType"></p-dropdown></span>
                                <span *ngIf="dupType == 2" class="ml-3">Minimalmenge pro Schlüsselkombination: <p-inputNumber [(ngModel)]="minCount"></p-inputNumber></span>
                                <button pButton icon="fas fa-cog" label="Ermitteln" (click)="getDuplicateDatasets()"></button>
                            </sm-toolbar>
                            <sm-table2 class="flex-item-fill height100p" [data]="fieldsSelectTable"></sm-table2>
                        </div>
                    </p-tabPanel>
                    <p-tabPanel *ngIf="duplicateDatasetsTable != null" header="Ergebnis">
                        <div class="flex-col height100p">
                            <sm-toolbar *ngIf="noDupIds || duplicateDatasets.length > 0">
                                <button pButton *ngIf="!noDupIds && duplicateDatasets.length > 0" icon="fas fa-copy" label="Doppelte IDs kopieren (außer Älteste)" (click)="copyDupIds(true)"></button>
                                <button pButton *ngIf="!noDupIds && duplicateDatasets.length > 0" icon="fas fa-copy" label="Doppelte IDs kopieren (außer Neueste)" (click)="copyDupIds(false)"></button>
                                <p-splitButton *ngIf="getSelectedObjectType() != null" icon="fas fa-open" label="Trefferliste in enaio öffnen" (onClick)="openDupsInEnaio()" [model]="openDupsMenu"></p-splitButton>
                                <p-message *ngIf="noDupIds" severity="danger" text="Das Anzeigen von IDs funktioniert nur für MSSQL >= 2017 oder Postgres"></p-message>
                            </sm-toolbar>
                            <sm-table2 class="flex-item-fill height100p" [data]="duplicateDatasetsTable"></sm-table2>
                        </div>
                    </p-tabPanel>
                </p-tabView>
            </p-tabPanel>
            <p-tabPanel header="Feldwerte suchen">
                <div class="height100p flex-row-split">
                    <p-panel class="flex-item-fixed width300 height100p full-height" header="Optionen">
                        <sm-form #form [form]="findValueForm">
                        </sm-form>
                        <p-button icon="fas fa-run" label="Suchen" (onClick)="findValues()"></p-button>
                    </p-panel>
                    <sm-table2 *ngIf="findValueTable != null" class="flex-item-fill height100p" [data]="findValueTable"></sm-table2>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Alle Felder">
                <div class="height100p flex-col">
                    <sm-toolbar>
                        <button pButton icon="fas fa-refresh" label="Aktualisieren" (click)="fillAllFields()"></button>
                    </sm-toolbar>
                    <sm-table2 *ngIf="allFieldsTable != null" class="flex-item-fill" [allowFilter]=true [floatingFilter]=true [data]="allFieldsTable"></sm-table2>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Historie">
                <div class="height100p flex-row-split">
                    <p-panel class="flex-item-fixed width300 height100p full-height" header="Optionen">
                        <sm-form #form [form]="historyForm">
                        </sm-form>
                        <p-button icon="fas fa-run" label="Ermitteln" (onClick)="loadHistory()"></p-button>
                    </p-panel>
                    <sm-table2 *ngIf="historyTable != null" class="flex-item-fill height100p" [data]="historyTable"></sm-table2>
            </div>
            </p-tabPanel>
            <p-tabPanel header="Statistiken">
                <div class="height100p flex-row-split">
                    <p-panel class="flex-item-fixed width300 height100p full-height" header="Optionen">
                        <sm-form #form [form]="statisticsForm">
                        </sm-form>
                        <p-button icon="fas fa-run" label="Ermitteln" (onClick)="loadStatistics()"></p-button>
                    </p-panel>
                    <sm-table2 *ngIf="statisticsTable" class="flex-item-fill height100p" [data]="statisticsTable" [horizontalScroll]=true></sm-table2>
            </div>
            </p-tabPanel>
            <p-tabPanel header="Visualisierung">
                <div class="height100p flex-row-split">
                    <p-panel class="flex-item-fixed width300 height100p full-height" header="Optionen">
                        <app-plot-definition #plotDefComponent [fields]="plotFields" [plot]="plotDefinition" [templates]="plotTemplates" (onStoreTemplate)="storePlotTemplate($event)"></app-plot-definition>
                        <p-button class="mt-3" icon="fas fa-chart-pie" label="Generieren" (onClick)="generatePlot()"></p-button>
                    </p-panel>
                    <div class="flex-item-fill height100p">
                        <app-plot #plot class="height100p mt-3"></app-plot>
                    </div>
                </div>
            </p-tabPanel>
        </p-tabView>
    </div>
    <app-progressor-overlay [progressor]="progressor.value"></app-progressor-overlay>
</app-wait-container>
